import React from 'react';
import Header from './Header';
import FilmStrip from './FilmStrip';

const TILES = [
  { key: 'gallery', icon: '▤', label: 'Galerie', sub: 'Fotky nožů' },
  { key: 'videos', icon: '▶', label: 'Videa', sub: 'Odkazy na YouTube' },
  { key: 'knives', icon: '✦', label: 'Volné nože', sub: 'Nabídka k prodeji' },
];

export default function Dashboard({ onSelect, onLogout }) {
  return (
    <div className="page">
      <Header eyebrow="HUGOKNIVES" title="Administrace" onLogout={onLogout} />
      <FilmStrip />

      <main className="main">
        <p className="dashboard__hint">Co chceš upravit?</p>

        <div className="dashboard__grid">
          {TILES.map((tile) => (
            <button
              key={tile.key}
              type="button"
              className="dashboard__tile"
              onClick={() => onSelect(tile.key)}
            >
              <span className="dashboard__tile-icon">{tile.icon}</span>
              <span className="dashboard__tile-label">{tile.label}</span>
              <span className="dashboard__tile-sub">{tile.sub}</span>
            </button>
          ))}
        </div>
      </main>

      <footer className="footer">
        <span className="footer__dot" /> Připojeno k backendu
      </footer>
    </div>
  );
}
